module.exports = __webpack_public_path__ + "img/12.d19c2be8.webp";